import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IBaseBusinessRepository } from '@/coreInfrastructureModule/interfaces/IBaseBusinessRepository';
import { BulkUpdateBaseBusinessUserIdAdapter } from '../adapter/bulkUpdateBaseBusinessUserIdAdapter';

/**
 * 関連取引が持つ客先内示担当者IDを一括で更新するUseCase
 */
export class BulkUpdateBaseBusinessUserIdUseCase {
  /**
   * 客先内示担当者IDを更新する
   * @param repository - リポジトリ
   * @param baseBusinessIds - 対象の関連ID
   * @param userIds - 担当者IDリスト
   */
  public async Execute(
    repository: IBaseBusinessRepository,
    baseBusinessIds: string[],
    userIds: string[]
  ): Promise<INetworkResult<void, Error>> {
    try {
      const request = BulkUpdateBaseBusinessUserIdAdapter.adaptForRequest(baseBusinessIds, userIds);
      const response = await repository.updateBaseBusinessUserId(request);
      switch (response.status.type) {
        case 'success':
          break;
        case 'error':
          throw response.status.error;
        default:
          throw new Error('Invalid status');
      }
      return {
        status: {
          type: 'success',
          data: undefined,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('編集に失敗しました。再度編集してください。'),
        },
      };
    }
  }
}
